import React from 'react';
import ArrowBindingHint from './ArrowBindingHint';
import ArrowTerminalLabels from './ArrowTerminalLabels';
import MeaningHoverOverlay from './MeaningHoverOverlay';
import ObjectProcessingOverlay from './ObjectProcessingOverlay';
import PinEpistemicLabels from './PinEpistemicLabels';
import TextAboutObjectHint from './TextAboutObjectHint';
import TextShapeDigest from './TextShapeDigest';
import ImageShapeDigest from './ImageShapeDigest';
import CanvasEvidenceDigest from './CanvasEvidenceDigest';
import ArrowRelationDigest from './ArrowRelationDigest';
import FrameClusterDigest from './FrameClusterDigest';
import CanvasFocusTracker from './CanvasFocusTracker';

/** Screen-space overlays in front of the canvas. */
export default function CanvasFrontOverlays() {
  return (
    <>
      <TextShapeDigest />
      <ImageShapeDigest />
      <CanvasEvidenceDigest />
      <ArrowRelationDigest />
      <FrameClusterDigest />
      <CanvasFocusTracker />
      <ArrowTerminalLabels />
      <MeaningHoverOverlay />
      <ObjectProcessingOverlay />
      <PinEpistemicLabels />
      <TextAboutObjectHint />
      <ArrowBindingHint />
    </>
  );
}
